import type { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { isOverlayBlockedForPath, resolveRouteContextFamily } from "@Front/Utils/routeContextRegistry";

export function isAuthFlowPathForNotaryEmailGate(pathname: string | undefined): boolean {
	return isOverlayBlockedForPath({
		overlay: "notary_missing_contact_email",
		pathname,
		routeContextFamily: resolveRouteContextFamily(pathname),
	});
}

export function isExcludedUserTypeForNotaryEmailGate(userType: string | null | undefined): boolean {
	const ut = userType?.toLowerCase() ?? "";
	return ut === "customer" || ut === "thirdparty";
}

export function shouldEvaluateNotaryMissingEmailPrompt(params: {
	permissionsLoading: boolean;
	permissionContext: PermissionContextDto | null;
	pathname: string | undefined;
	hasOfficeFoldersRead: boolean;
}): boolean {
	const { permissionsLoading, permissionContext, pathname, hasOfficeFoldersRead } = params;
	if (permissionsLoading || !permissionContext?.userId) {
		return false;
	}
	if (!hasOfficeFoldersRead) {
		return false;
	}
	if (isExcludedUserTypeForNotaryEmailGate(permissionContext.userType)) {
		return false;
	}
	if (isAuthFlowPathForNotaryEmailGate(pathname)) {
		return false;
	}
	return true;
}

/** Priorité : fiche `GET users` si chargée ; sinon email issu de `GET my-permissions` (`contactEmail`). */
export function resolveEffectiveNotaryContactEmailForGate(params: {
	userContactEmail: string | null | undefined;
	permissionContext: PermissionContextDto | null;
}): string | null | undefined {
	const fromUser = params.userContactEmail?.trim();
	if (fromUser) {
		return fromUser;
	}
	const fromContext = params.permissionContext?.contactEmail?.trim();
	if (fromContext) {
		return fromContext;
	}
	return params.userContactEmail ?? params.permissionContext?.contactEmail ?? undefined;
}

export type NotaryEmailModalOpenDerivation = {
	open: boolean;
	clearDismissKey: boolean;
};

export function deriveNotaryEmailModalOpenState(params: {
	shouldConsider: boolean;
	userUid: string | undefined;
	contactEmail: string | null | undefined;
	dismissedInSession: boolean;
}): NotaryEmailModalOpenDerivation {
	const { shouldConsider, userUid, contactEmail, dismissedInSession } = params;
	if (!shouldConsider || !userUid) {
		return { open: false, clearDismissKey: false };
	}
	const hasEmail = Boolean(contactEmail?.trim());
	if (hasEmail) {
		return { open: false, clearDismissKey: true };
	}
	if (dismissedInSession) {
		return { open: false, clearDismissKey: false };
	}
	return { open: true, clearDismissKey: false };
}
